import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { MyRequestsPage } from "@/screens/Dashboard/components/MyRequestsPage"
import { qualityRequestSearchSchema } from "@/screens/Dashboard/schemas"

export const Route = createFileRoute("/app/dashboard/_layout/my-requests")({
  validateSearch: zodValidator(qualityRequestSearchSchema),
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.DASHBOARD_MY_REQUESTS]}>
      <MyRequestsPage />
    </PermissionContentWrapper>
  ),
})
